<template>
    <component
        :is="baseComponent"
        v-if="visible"
        ref="appBar"
        flat
        scroll-behavior="hide"
        scroll-threshold="1"
        class="header pl-sm-4"
        :height
        :color="defaultStates.HEADER_BAR_THEME_DARK ? null : 'white'"
        :theme="defaultStates.HEADER_BAR_THEME_DARK ? 'dark' : 'light'"
        extension-height="0"
    >
        <template v-slot:prepend>
            <div class="d-flex flex-wrap-reverse gc-5">
                <header-block style="min-width: 120px" />
                <contacts-block v-if="!$breakpoint.smAndDown" />
            </div>
        </template>
        <v-spacer />
        <client-only>
            <div v-if="$breakpoint.mdAndUp" class="header-bar-menu d-md-flex d-lg-flex align-center">
                <template
                    v-if="
                        !['authorization', 'b2b-auth', 'restore-password', 'hotelDirectory'].includes(
                            $route.name as string
                        ) ||
                        ($route.name === 'hotelDirectory' && person)
                    "
                >
                    <account-menu />
                </template>
                <language-switcher v-else />
            </div>
        </client-only>
        <template v-slot:append>
            <v-app-bar-nav-icon v-if="$breakpoint.smAndDown" @click.stop="drawer = !drawer" />
        </template>
        <template v-if="extension" v-slot:extension>
            <div v-if="$breakpoint.smAndDown" id="under-header" class="w-100" />
            <slot name="alerts" />
        </template>
    </component>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'
    import CurrencySwitcher from '~/components/CurrencySwitcher.vue'
    import AccountMenu from '~src/components/account/accountMenu.src'
    import {EventBus, FULL_SCREEN_MODE} from '@/utils/event-bus'
    import LanguageSwitcher from '~/components/LanguageSwitcher.vue'
    import HeaderBlock from '~src/components/snippets/headerBlock.src'
    import ContactsBlock from '~src/components/snippets/contactsBlock.src'
    import {VAppBar} from 'vuetify/components/VAppBar'
    import {VToolbar} from 'vuetify/components/VToolbar'

    @Component({
        components: {
            ContactsBlock,
            HeaderBlock,
            AccountMenu,
            LanguageSwitcher,
            CurrencySwitcher,
            VAppBar,
            VToolbar,
        },
    })
    export class HeaderBar extends Vue {
        @Prop({default: false, type: Boolean}) extension
        @Prop({default: 70, type: Number}) scrollThreshold
        @VModel() drawer

        visible = true
        height = 0
        observer = null

        mounted() {
            if (this.isMobile) {
                this.setPageOnScrollListener()
            }
            EventBus.$on(FULL_SCREEN_MODE, this.toggle)
            window.addEventListener('scroll', this.handleScroll)

            this.observer = new MutationObserver(() => {
                this.height = this.$refs.appBar.$el.getBoundingClientRect().height
            })
            this.observer.observe(this.$refs.appBar.$el, {childList: true, subtree: true})
        }

        setPageOnScrollListener() {
            let prevScrollPos = window.pageYOffset

            document.addEventListener('scroll', () => {
                const currentScrollPos = window.pageYOffset
                if (this.$refs.header) {
                    if (prevScrollPos <= currentScrollPos) {
                        this.$refs.header.classList.add('hide')
                        document.querySelector('.show-scroll-up-mobile')?.classList.add('hide')
                    } else {
                        this.$refs.header.classList.remove('hide')
                        document.querySelector('.show-scroll-up-mobile')?.classList.remove('hide')
                    }
                }

                prevScrollPos = currentScrollPos
            })
        }

        beforeUnmount() {
            EventBus.$off(FULL_SCREEN_MODE, this.toggle)
            window.removeEventListener('scroll', this.handleScroll)
            if (this.observer) {
                this.observer.disconnect()
            }
        }

        handleScroll() {
            // if (this.isMobile) this.visible = window.scrollY <= this.scrollThreshold
        }

        toggle(fullScreenMode) {
            // this.visible = !fullScreenMode
        }

        get person() {
            return authStore.person
        }

        get isMobile() {
            return this.$breakpoint.smAndDown
        }

        get personRole() {
            return authStore.personRole
        }

        get baseComponent() {
            return this.isMobile ? resolveComponent('VAppBar') : resolveComponent('VToolbar')
        }
    }

    export default HeaderBar
</script>

<style scoped lang="scss">
    :deep(.v-toolbar__extension) {
        height: auto !important;
        flex-direction: column !important;
    }
</style>
